module.exports = __webpack_public_path__ + "img/laf.c6f1c3e1.webp";